module.exports = __webpack_public_path__ + "img/42_13.192fa9ad.png";